export const mainRemittances = {
    title: "Remise de chèques",
    text: "Vous devez sélectionner une remise existante ou en créer une nouvelle."
}